import { canUseDOM } from "./dom";
export function genrateHeadingWithFirstName(originalHeading, firstname) {
  if (!canUseDOM()) return;
  let node = document.createElement("div");
  node.innerHTML = originalHeading?.value;

  //get styled applied by editor so we can keep it
  let typographyClass =
    node.firstChild && node.firstChild.className
      ? node.firstChild.className
      : "";

  return {
    value: `<span class=${typographyClass}>${
      originalHeading?.value
    } ${firstname || ""}</span>`
  };
}
